const convertStringIntoNumber = (str = '') => {
  const result = str.replace('₹', '');
  return result.split(',').join('');
};

export const modifyResponseForProductList = (response = []) => {
  let firstCategory;
  const data = {
    linkoutTarget: '_blank',
    tabs: [],
    items: [],
  };
  if (response.length > 1) {
    data.tabs.push({
      label: 'All Options',
      id: 'all_options',
      active: true,
      data: [],
    });
  }

  response.forEach((category = {}, index) => {
    const subContent = category.subContent || [];
    const categoryName = category.content || '';
    const tabData = {
      id: categoryName,
      label: categoryName.replace('_', ' '),
      data: [],
    };

    subContent.forEach(content => {
      const properties = content.properties || {};
      const listPrice = convertStringIntoNumber(properties.listPrice);
      const price = convertStringIntoNumber(properties.price);
      let imageURL = properties.thumbnail || '';
      imageURL = imageURL.replace('.jpg', '._SL300.jpg');

      const discount = Math.round((listPrice - price) / listPrice * 100);
      const productData = {
        title: properties.title,
        listPrice,
        price,
        url: properties.deepLink,
        imageURL,
        productID: content.content,
        logoURL:
          'https://static.toiimg.com/thumb/height-30,resizemode-4,msid-104038499/104038499.jpg',
        discount,
      };
      if (productData.url) {
        productData.url = productData.url.split('?')[0];
      }
      tabData.data.push(productData);
      data.items.push(productData);
    });
    if (response.length > 1) {
      data.tabs[0].data = data.items;
    }
    if (index > 0) {
      data.tabs.push(tabData);
    } else {
      firstCategory = tabData;
    }
  });
  data.tabs.push(firstCategory);

  return { data };
};

export const mergeArrayAndRemoveDuplicates = (arr1, arr2) => {
  const resultMap = {};
  arr1.forEach(item => {
    if (!resultMap[item.productID]) {
      resultMap[item.productID] = item;
    }
  });
  arr2.forEach(item => {
    if (!resultMap[item.productID]) {
      resultMap[item.productID] = item;
    }
  });
  return Object.values(resultMap);
};

export const mergeTabsAndRemoveDuplicateProducts = result => {
  const { data: { tabs = [] } = {} } = result || {};
  if (tabs.length > 1) {
    const tabMap = {};
    tabs.forEach(tab => {
      if (tabMap[tab.id]) {
        tabMap[tab.id].data = mergeArrayAndRemoveDuplicates(
          tabMap[tab.id].data,
          tab.data,
        );
      } else {
        tabMap[tab.id] = tab;
      }
    });
    result.data.tabs = Object.values(tabMap);
  }
};

export const getAmazonLensApiUrl = msid => {
  const enocdedImageURL = encodeURIComponent(
    `https://static.toiimg.com/photo/${msid}.cms`,
  );
  const apiURL = `https://amazonlens.indiatimes.com/image/upload/aws?fileUrl=https://static.toiimg.com/photo/${enocdedImageURL}.cms`;
  return apiURL;
};
